export enum PresetApiStateEnum {
  idle,
  loading,
  success,
  error,
}